function isValidMargin(margin) {
  return typeof margin === "string" || typeof margin === "number";
}

var MARGINS = {
  m: "margin",
  mt: "marginTop",
  mb: "marginBottom",
  ml: "marginLeft",
  mr: "marginRight"
};

function getMargins(margins, theme) {
  var styles = {};

  if (isValidMargin(margins.my)) {
    var margin = theme.fn.size({
      size: margins.my,
      sizes: theme.spacing
    });
    styles.marginTop = margin;
    styles.marginBottom = margin;
  }

  if (isValidMargin(margins.mx)) {
    var _margin = theme.fn.size({
      size: margins.mx,
      sizes: theme.spacing
    });

    styles.marginLeft = _margin;
    styles.marginRight = _margin;
  }

  Object.keys(MARGINS).forEach(function (margin) {
    if (isValidMargin(margins[margin])) {
      styles[MARGINS[margin]] = theme.fn.size({
        size: margins[margin],
        sizes: theme.spacing
      });
    }
  });
  return styles;
}

export { getMargins };